import { createReducer, on, Action } from '@ngrx/store';
import { Campus } from '@uc/web/shared/data-models';

import * as StateCampusLocationsActions from './campus-locations.actions';

export const _STATE_CAMPUS_LOCATIONS_FEATURE_KEY = 'stateCampusLocations';

export interface CampusLocationsState {
	campus: Campus | null;
	selectedUniversityUrl: string;
	loaded: boolean;
	error?: string | null;
}

export interface CampusLocationsPartialState {
	readonly [_STATE_CAMPUS_LOCATIONS_FEATURE_KEY]: CampusLocationsState;
}

export const campusLocationsInitialState: CampusLocationsState = {
	// set initial required properties
	campus: null,
	selectedUniversityUrl: '',
	loaded: false,
};

const stateCampusLocationsReducer = createReducer(
	campusLocationsInitialState,
	on(StateCampusLocationsActions.fetchCampusesList, (state) => ({
		...state,
		loaded: false,
		error: null,
	})),
	on(StateCampusLocationsActions.updateCampusesList, (state, stateCampus) => ({
		...state,
		loaded: true,
		campus: stateCampus,
		error: null,
	})),
	on(
		StateCampusLocationsActions.updateCampusLocationsUniversityUrl,
		(state, stateUniversityUrl) => ({
			...state,
			loaded: true,
			selectedUniversityUrl: stateUniversityUrl.universityUrl,
			error: null,
		}),
	),
	on(
		StateCampusLocationsActions.loadStateCampusLocationsFailure,
		(state, { error }) => ({
			...state,
			error,
		}),
	),
);

export function campusLocationsReducer(
	state: CampusLocationsState | undefined,
	action: Action,
) {
	return stateCampusLocationsReducer(state, action);
}
